class menusetCtrl {
    constructor($rootScope, $scope, httpRequest) {
        $('body').addClass('leftnav-close')
        $rootScope.leftNavDisabled = true
        const buildTree = function (list) {
            // 适配树组件数据结构
            function recursion(data, pid) {
                const result = []
                let temp
                for (const i in data) {
                    if (data[i].parentFunctionId == pid) {
                        result.push(data[i])
                        temp = recursion(data, data[i].functionId)
                        if (temp.length > 0) {
                            data[i].childFuncList = temp
                        }
                    }
                }
                return result
            }
            return recursion(list, -1)
        }
        const getSelectedItem = function (treeData) {
            // 递归树 获取选中项返回展平数组
            const result = []
            var recursionTree = function (nodes, cb) {
                for (const i in nodes) {
                    cb(nodes[i])
                    if (nodes[i].childFuncList) {
                        recursionTree(nodes[i].childFuncList, cb)
                    }
                }
            }
            recursionTree(treeData, (item) => {
                if (item.selected == true) {
                    result.push(item.functionId)
                }
            })
            return result
        }
        const getSelectedItemDate = function (treeData) {
            // 递归树 获取选中项返回展平数组
            const result = []
            var recursionTree = function (nodes, cb) {
                for (const i in nodes) {
                    cb(nodes[i])
                    if (nodes[i].childFuncList) {
                        recursionTree(nodes[i].childFuncList, cb)
                    }
                }
            }
            recursionTree(treeData, (item) => {
                if (item.selected == true) {
                    result.push(item)
                }
            })
            return result
        }
        const setTreeSelected = function (treeData, selectedItems) {
            // 递归树 比较选中项目 设置 selected
            var recursionTree = function (nodes, cb) {
                for (const i in nodes) {
                    cb(nodes[i])
                    if (nodes[i].childFuncList) {
                        recursionTree(nodes[i].childFuncList, cb)
                    }
                }
            }
            recursionTree(treeData, (item) => {
                for (const i in selectedItems) {
                    if (item.functionId == selectedItems[i]) {
                        item.selected = true
                    }
                }
            })
        }
        const setTreeDisabled = function (treeData, selectedItems, bl) {
            // 递归树 比较选中项目 设置 disabled
            var recursionTree = function (nodes, cb) {
                for (const i in nodes) {
                    cb(nodes[i])
                    if (nodes[i].childFuncList) {
                        recursionTree(nodes[i].childFuncList, cb)
                    }
                }
            }
            recursionTree(treeData, (item) => {
                let isSelected = false
                for (const i in selectedItems) {
                    if (item.functionId == selectedItems[i]) {
                        isSelected = true
                    }
                }
                if (!isSelected) {
                    item.cbDisable = bl
                }
            })
        }

        $scope.onSelected = function (node) {
            console.log(node)
        }
        // 处理需求--常用菜单设置应该最多设置9个常用三级菜单，超过9个则不允许勾选
        $scope.stChangeHandle = function (node, parentNodes) {
            const flag = node.selected
            const fnIdList = getSelectedItem($scope.fnTree)
            const fnIdListLength = fnIdList.length
            if (fnIdListLength == 9 && flag) {
                setTreeDisabled($scope.fnTree, fnIdList, true)
            }
            if (fnIdListLength == 8 && !flag) {
                setTreeDisabled($scope.fnTree, fnIdList, false)
            }
        }
        httpRequest.get_getFunctionListByUser().then((res) => {
            $scope.fnTree = buildTree(res.data.value)
            httpRequest.get_getUserCustomized(1).then((res) => {
                const fnIds = res.data.value || ''
                const fnIdList = fnIds.split(',')
                setTreeSelected($scope.fnTree, fnIdList)
                if (fnIdList.length >= 9) {
                    setTreeDisabled($scope.fnTree, fnIdList, true)
                } else {
                    setTreeDisabled($scope.fnTree, fnIdList, false)
                }
            })
        })


        $scope.submit = function () {
            // profileType = 1  設置id list
            // profileType = 2  设置菜单 list
            const fnIdList = getSelectedItem($scope.fnTree)
            const fnItemList = getSelectedItemDate($scope.fnTree)
            console.log(fnIdList)
            console.log(fnItemList)
            const req = {
                profileInfo: fnIdList.join(','),
                profileType: '1', // 类型需要定义为常量 放在es6 常量模块里  后面提取
            }
            httpRequest.post_saveUserCustomized(req).then((res) => {
                const req2 = {
                    profileInfo: JSON.stringify(fnItemList),
                    profileType: '2', // 类型需要定义为常量 放在es6 常量模块里  后面提取
                }
                httpRequest.post_saveUserCustomized(req2, '保存成功').then((res) => {
                    $rootScope.$broadcast('getUserCustomizedChanged')
                    $('body').removeClass('leftnav-close')
                    $rootScope.leftNavDisabled = false
                    history.back()
                })
            })
        }
        // 取消
        $scope.cancel = function () {
            $('body').removeClass('leftnav-close')
            $rootScope.leftNavDisabled = false
            history.back()
        }
    }
}
menusetCtrl.$inject = ['$rootScope', '$scope', 'httpRequest']
export default menusetCtrl



// WEBPACK FOOTER //
// ./src/app/main/setting/menusetCtrl.js